<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <LoadCard v-if="load"></LoadCard>

        <DashboardCard v-else>
            <blockquote class="card-blockquote">
                <b-icon icon="calendar2-week" class="icone-Meet"></b-icon>
                <p>Reuniones registradas</p>

                <footer>
                    <h2>{{ getCount }}</h2>
                </footer>

            </blockquote>
        </DashboardCard>
    </div>
</template>
<script>

//signal R
import { hub } from '@/plugins/signalR/index.js';
import { ReceiveHubs, Hubs as namesHub } from '@/plugins/enums/index.js';

//alerta
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import LoadCard from '@/components/shared/Load-card.vue'
import DashboardCard from '@/components/shared/Dashboard-card.vue'

//mixin
import { dashboardGraph } from '@/plugins/mixin/index.js'

export default {
    name: 'MeetingCountGraph',

    mixins: [dashboardGraph],

    data() {
        return {
            count: 0,
            load: true,

            connection: null
        }
    },

    async created() {
        this.connection = hub.getInstance(namesHub.meetHub)
        await this.connection.start();

        this.countMeetsSignalR(this.connection);
    },

    beforeDestroy() {
        this.connection.off(ReceiveHubs.meetHub);
    },

    components: {
        AlertDismiss,
        LoadCard,
        DashboardCard
    },

    computed: {
        getCount() {
            return this.count;
        }
    },

    methods: {
        countMeetsSignalR(connection) {
            connection.on(ReceiveHubs.countMeets, (count) => {
                try {
                    if (this.getGraph.mixinItUpdates) { this.count = count; }
                } catch (error) {
                    this.$refs.alertDismiss.showAlert("Error en la gráfica que representa las cantidades de documentos");
                }

                this.load = false;
            });
        }
    }

}
</script>
<style scoped>
</style>